import { vec3 } from 'gl-matrix';
import { isEqual } from '../isEqual.js';
import { getDisplayHalfWidth, SLAB_RELATIVE_EPSILON } from './slabMembership.js';
export function isPlaneDepthViewable(planePoint, focalPoint, viewPlaneNormal, referencePlaneThickness, viewportSlabThickness = 0) {
    const pointVector = vec3.sub(vec3.create(), planePoint, focalPoint);
    const depth = vec3.dot(pointVector, viewPlaneNormal);
    if (!Number.isFinite(referencePlaneThickness)) {
        return isEqual(0, depth);
    }
    const halfWidth = getDisplayHalfWidth(viewportSlabThickness, referencePlaneThickness);
    return (Math.abs(depth) < halfWidth - Math.abs(halfWidth) * SLAB_RELATIVE_EPSILON);
}
